import { fork } from 'redux-saga/effects'
import { customerSharedSaga } from './shared'
import { customerStitchSaga } from './stitch'
import { customerDocusignSaga } from './docusign'
import { customerStepsSaga } from './steps'

export function* customerSaga() {
  yield fork(customerSharedSaga)
  yield fork(customerStepsSaga)
  yield fork(customerStitchSaga)
  yield fork(customerDocusignSaga)
}
